import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Itinerary extends Model {
  resource() {
    return 'admin/template'
  }

  get addedDate() {
    return dayjs
      .utc(this.created_at)
      .local()
      .format('MMM DD, YYYY hh:mm A')
  }

  get stopList() {
    return this.stops.map(function(obj) {
      return obj['id']
    })
  }

  get retailList() {
    return this.retails.map(function(obj) {
      return obj['id']
    })
  }

  get accommodationList() {
    return this.accommodations.map(function(obj) {
      return obj['id']
    })
  }
}
